import React from 'react'
import { Paragraph, colors, Separator, H5, H6 } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { Trans } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import transl from './SearchNarrowTips.trans'

export default function SearchNarrowTips({ searchTipsBody, withMargin = true }) {
  return (
    <div
      css={{
        background: colors.gray03,
        borderRadius: '16px',
        margin: withMargin ? '20px' : '0px',
        padding: '20px 30px',
      }}
    >
      <H5>{transl.noResultsHeading()}</H5>
      <div>{searchTipsBody}</div>
    </div>
  )
}

export function SearchResultsNarrowTips() {
  const linkUrl = `https://community.familysearch.org/${i18n.language}/categories/gp-groups-${i18n.language}`

  const searchTipsBody = (
    <>
      <Trans i18nKey="searchLimitParagraph" defaults={transl.searchLimitParagraph()} />
      <Separator size="xs" />
      <H6>{transl.placeHeading()}</H6>
      <Trans i18nKey="placesWithinParagraph" defaults={transl.placesWithinParagraph()} />
      <Separator size="xs" />
      <H6>{transl.lifeEvent()}</H6>
      <Trans i18nKey="lifeEventParagraph" defaults={transl.lifeEventParagraph()} />
      <Separator size="xs" />
      <H6>{transl.date()}</H6>
      <Trans i18nKey="dateParagraph" defaults={transl.dateParagraph()} />
      <Separator size="xs" />
      <H6>{transl.imageGroup()}</H6>
      <Trans i18nKey="imageGroupParagraph" defaults={transl.imageGroupParagraph()} />
      <Separator size="xs" />
      <H6>{transl.keyword()}</H6>
      <Trans i18nKey="keywordParagraph" defaults={transl.keywordParagraph()} />
      <Separator size="xs" />
      <H6>{transl.communtiyTitle()}</H6>
      <Paragraph size="sm">
        <Trans
          i18nKey="joinACommunityParagraph"
          defaults={transl.communityParagraph()}
          components={{
            communityLink: <Link to={linkUrl} target="_blank" external />,
          }}
        />
      </Paragraph>
    </>
  )

  return <SearchNarrowTips searchTipsBody={searchTipsBody} />
}

export function CollectionResultsNarrowTips() {
  const searchTipsBody = (
    <>
      <Trans i18nKey="collectionsResultNarrowTip1" defaults={transl.collectionsResultNarrowTip1()} />
      <Separator size="xs" />
      <Trans i18nKey="collectionsResultNarrowTip2" defaults={transl.collectionsResultNarrowTip2()} />
      <Separator size="xs" />
    </>
  )

  return <SearchNarrowTips searchTipsBody={searchTipsBody} withMargin={false} />
}
